<script>
  import ResponsiveTable from "@/core/components/table/ResponsiveTable"

  export default {
    components: { ResponsiveTable },
    props: {
      filters: { type: Object, default: () => ({}) },
    },

    data() {
      return {
        status: "pending",

        headers: [
          {
            value: "matricula",
            text: "Matrícula",
          },
          {
            value: "nome",
            text: "Nome",
          },
          {
            value: "situacao",
            text: "Situação",
          },
          {
            value: "categoria",
            text: "Categoria",
          },
          {
            value: "modalidade",
            text: "Modalidade",
          },
          {
            value: "escala",
            text: "Escala",
          },
          {
            value: "vencimento",
            text: "Vencimento",
          },
          {
            value: "orgao",
            text: "Órgão",
          },
          {
            value: "municipio",
            text: "Município",
          },
        ],

        page: 1,
        perPage: 50,

        items: [],

        // IMPORTANTE: manter sempre as mesmas chaves (Vue2 reatividade)
        pagination: {
          current_page: 1,
          per_page: 50,
          total: 0,
        },

        municipiosMap: {
          4540: "Itajaí",
          4583: "Navegantes",
        },

        // evita reload duplicado quando filtros mudam rápido
        loading: false,
      }
    },

    mounted() {
      this.load()
    },

    methods: {
      resetAndReload() {
        this.page = 1
        this.load()
      },

      buildPayload() {
        const f = this.filters || {}

        return {
          // padrão financeiro: search opcional e sempre filters/orderBy
          search: f.search ? String(f.search).trim() : null,

          filters: {
            situacao: f.situacao_id ? [String(f.situacao_id)] : [],
            categoria: f.categoria_id ? [String(f.categoria_id)] : [],
            modalidade: f.modalidade_id ? [String(f.modalidade_id)] : [],
            instituicao_nome: f.instituicao_nome
              ? String(f.instituicao_nome).trim()
              : null,
            municipio: f.municipio_id ? [String(f.municipio_id)] : [],
            escala:
              f.escala !== "" && f.escala != null ? [String(f.escala)] : [],
            periodo_inicial: f.periodo_inicial || null,
            periodo_final: f.periodo_final || null,
          },

          orderBy: { idbeneficiario: "DESC" },

          // o backend lê per_page do body
          per_page: this.perPage,
        }
      },

      mapBeneficiarioItem(item) {
        const situacaoId = this.toStringSafe(item.idsituacao)
        const categoriaId = this.toStringSafe(item.tpbeneficiario)
        const modalidadeId = this.toStringSafe(item.tplocomocao)
        const municipioId = this.toStringSafe(item.numunicipio)
        const instituicaoId = this.toStringSafe(item.idinstituicao)

        const escala = this.mapEscala(item.fljornada)
        const vencimento = this.mapDate(item.dtexpiracao)

        return {
          matricula: item.idbeneficiario,
          nome: item.nmnome || "",

          situacao_id: situacaoId,
          situacao_label: this.mapSituacaoLabel(situacaoId),

          categoria_id: categoriaId,
          categoria_label: this.mapCategoriaLabel(categoriaId),

          modalidade_id: modalidadeId,
          modalidade_label: this.mapModalidadeLabel(modalidadeId),

          instituicao_id: instituicaoId,
          instituicao_nome: this.toStringSafe(item.instituicao_nome),
          instituicao_label: this.toStringSafe(item.instituicao_label),

          municipio_id: municipioId,
          municipio_label: this.municipiosMap[municipioId] || municipioId,

          escala_value: escala.value,
          escala_label: escala.label,

          vencimento_iso: vencimento.iso,
          vencimento_label: vencimento.label,
        }
      },

      toStringSafe(value) {
        return value != null ? String(value) : ""
      },

      mapEscala(flag) {
        const value = flag === true ? "12x36" : "normal"

        return {
          value,
          label: value === "normal" ? "Normal" : "12x36",
        }
      },

      mapDate(date) {
        if (!date) {
          return {
            iso: "",
            label: "",
          }
        }

        const iso = String(date).slice(0, 10)
        const parsed = new Date(`${iso}T00:00:00`)

        return {
          iso,
          label: parsed.toLocaleDateString("pt-BR"),
        }
      },

      async load() {
        if (this.loading) {
          return
        }
        this.loading = true

        this.status = "pending"
        this.$Progress.start()

        try {
          const resp = await this.$axios.post(
            `/api/spl-navegantes/beneficiarios/relatorio?page=${this.page}`,
            this.buildPayload()
          )

          const p = resp.data?.sucess || {}
          const raw = Array.isArray(p.data) ? p.data : []

          this.items = raw.map(this.mapBeneficiarioItem)

          // NÃO altere this.perPage aqui (evita loop do watch)
          // Atualiza somente paginação e page (page não tem watch)
          this.pagination.current_page = Number(
            p.current_page || this.page || 1
          )
          this.pagination.per_page = Number(p.per_page || this.perPage || 50)
          this.pagination.total = Number(p.total || 0)

          this.page = this.pagination.current_page

          this.status = "finished"
        } catch (e) {
          this.items = []
          this.pagination.current_page = 1
          this.pagination.total = 0
          this.status = "rejected"
          this.$toast?.error?.({
            message:
              e.response?.data?.error ||
              e.response?.data?.message ||
              "Erro ao carregar relatório.",
          })
        } finally {
          this.$Progress.finish()
          this.loading = false
        }
      },

      changePage(p) {
        const next = Number(p || 1)
        if (next !== this.page) {
          this.page = next
          this.load()
        }
      },

      mapSituacaoLabel(id) {
        switch (String(id)) {
          case "1":
          case "2":
            return "ANALISADO"
          case "3":
            return "ATIVO"
          case "4":
            return "VENCIDO"
          case "5":
            return "PENDENTE"
          case "6":
            return "CANCELADO"
          case "7":
            return "A VENCER"
          default:
            return ""
        }
      },

      mapCategoriaLabel(id) {
        switch (String(id)) {
          case "1":
            return "Estudante"
          case "2":
            return "Trabalhador"
          case "3":
            return "Estagiário"
          default:
            return ""
        }
      },

      mapModalidadeLabel(id) {
        switch (String(id)) {
          case "1":
            return "Pedestre"
          case "2":
            return "Ciclista"
          case "3":
            return "Motociclista"
          default:
            return ""
        }
      },

      dataMap(rows) {
        return rows.map((r) => ({
          matricula: r.matricula,
          nome: r.nome,
          situacao: r.situacao_label,
          categoria: r.categoria_label,
          modalidade: r.modalidade_label,
          escala: r.escala_label,
          vencimento: r.vencimento_label,
          orgao: r.instituicao_label || "",
          municipio: r.municipio_label,
        }))
      },
    },
  }
</script>

<template>
  <div>
    <ResponsiveTable
      :headers="headers"
      :data="dataMap(items)"
      :pagination="pagination"
      :disabled="status === 'pending'"
      :status="status"
      v-on:changePage="page => changePage(page)"
    />
  </div>
</template>
